import React, { useState, useEffect } from 'react';

const ImageChecker = () => {
  const [results, setResults] = useState({});
  const [loading, setLoading] = useState(true);

  // All image paths to check from the different pages
  const imagesToCheck = [
    // Gallery images
    '/images/gallery/courses/1.jpg',
    '/images/gallery/courses/2.jpg',
    '/images/gallery/courses/3.jpg',
    '/images/gallery/courses/4.jpg',
    '/images/gallery/workshops/1.jpg',
    '/images/gallery/workshops/2.jpg',
    '/images/gallery/workshops/3.jpg',
    '/images/gallery/workshops/4.jpg',
    '/images/gallery/events/1.jpg',
    '/images/gallery/events/2.jpg',
    '/images/gallery/events/3.jpg',
    '/images/gallery/events/4.jpg',
    
    // News images
    '/images/news/nie.jpg',
    '/images/news/lion.jpg',
    '/images/news/slass.jpg',
    '/images/news/slass1.jpg',
    '/images/news/stemkit.jpg',
    
    // Events images
    '/images/coming_events/rc_c.jpg',
    '/images/coming_events/stemworkshop.jpg',
    '/images/coming_events/scl.jpg',
    '/images/coming_events/rbot.jpg',
    '/images/coming_events/ol.jpg',
    '/images/coming_events/3d.jpg',
  ];

  useEffect(() => {
    const checkImages = async () => {
      const results = {};
      
      // Create an array of promises to check if each image loads
      const promises = imagesToCheck.map((path) => {
        return new Promise((resolve) => {
          const img = new Image();
          img.onload = () => resolve({ path, status: 'success' });
          img.onerror = () => resolve({ path, status: 'error' });
          img.src = path;
        });
      });
      
      // Wait for all images to be checked
      const imageResults = await Promise.all(promises);
      
      // Group results by status
      imageResults.forEach(result => {
        results[result.path] = result.status;
      });
      
      setResults(results);
      setLoading(false);
    };
    
    checkImages();
  }, []);

  if (loading) {
    return <div className="p-4">Checking images...</div>;
  }

  const successImages = Object.keys(results).filter(path => results[path] === 'success');
  const failedImages = Object.keys(results).filter(path => results[path] === 'error');

  return (
    <div className="p-4">
      <h2 className="text-xl font-bold mb-4">Image Status Check</h2>
      
      <div className="mb-4">
        <h3 className="text-lg font-semibold text-green-600">Successfully Loaded Images ({successImages.length})</h3>
        <ul className="list-disc pl-6">
          {successImages.map(path => (
            <li key={path}>{path}</li>
          ))}
        </ul>
      </div>
      
      {failedImages.length > 0 ? (
        <div>
          <h3 className="text-lg font-semibold text-red-600">Failed to Load Images ({failedImages.length})</h3>
          <ul className="list-disc pl-6">
            {failedImages.map(path => (
              <li key={path}>{path}</li>
            ))}
          </ul>
          <p className="mt-4 text-orange-600">
            To fix failed images, ensure they exist in the correct public folder path.
          </p>
        </div>
      ) : (
        <p className="text-green-600 font-semibold">All images loaded successfully! 🎉</p>
      )}
    </div>
  );
};

export default ImageChecker; 